(function () {
  // ---- utilidades de reset/play ----
  function resetHtml5Video(vid) {
    try {
      vid.currentTime = 0;
      const p = vid.play && vid.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    } catch (_) {}
  }

  function resetYouTube(iframe) {
    try {
      // exige enablejsapi=1
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "seekTo", args: [0, true] }),
        "*"
      );
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "playVideo", args: [] }),
        "*"
      );
    } catch (_) {}
  }

  function resetVimeo(iframe) {
    try {
      // exige api=1
      iframe.contentWindow.postMessage({ method: "setCurrentTime", value: 0 }, "*");
      iframe.contentWindow.postMessage({ method: "play" }, "*");
    } catch (_) {}
  }

  function playIn(container) {
    if (!container) return;
    // HTML5
    container.querySelectorAll("video").forEach(resetHtml5Video);
    // Externos
    container.querySelectorAll("iframe.pc-video-iframe").forEach((ifrm) => {
      const host = (ifrm.dataset.host || "").toLowerCase();
      if (host === "youtube") resetYouTube(ifrm);
      else resetVimeo(ifrm);
    });
  }

  // Encontra o slide pelo data-target da thumb
  function getSlideByTarget(target) {
    if (!target) return null;
    // #Slider-Gallery-* contém <li class="product__media-item" data-media-id="sectionId-mediaId">
    const galleries = document.querySelectorAll("[id^='Slider-Gallery-']");
    for (const ul of galleries) {
      const li = ul.querySelector(`.product__media-item[data-media-id="${target}"]`);
      if (li) return li;
    }
    return null;
  }

  // Após clicar numa thumb, resetamos quando o slide alvo entrar
  function handleThumbClick(ev) {
    const btn = ev.currentTarget;
    const liThumb = btn.closest(".thumbnail-list__item");
    if (!liThumb) return;
    const target = liThumb.getAttribute("data-target");
    // tenta tocar imediatamente o slide alvo
    const slide = getSlideByTarget(target);
    if (slide) {
      // tenta agora…
      playIn(slide);
      // …e novamente após a animação de transição do slider
      setTimeout(() => playIn(slide), 80);
      setTimeout(() => playIn(slide), 180);
    }
  }

  function bindThumbs() {
    document.querySelectorAll("[id^='Slider-Thumbnails-'] .thumbnail").forEach((btn) => {
      // evita múltiplos binds se re-renderizar
      if (!btn.dataset.pcBound) {
        btn.dataset.pcBound = "1";
        btn.addEventListener("click", handleThumbClick);
        btn.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") handleThumbClick(e);
        });
      }
    });
  }

  // Fallback: quando um slide vira is-active, garanta play
  function observeActiveSlides() {
    document.querySelectorAll("[id^='Slider-Gallery-']").forEach((ul) => {
      const mo = new MutationObserver((muts) => {
        muts.forEach((m) => {
          if (
            m.type === "attributes" &&
            m.target &&
            m.target.classList &&
            m.target.classList.contains("product__media-item") &&
            m.target.classList.contains("slider__slide") &&
            m.target.classList.contains("is-active")
          ) {
            playIn(m.target);
          }
        });
      });
      mo.observe(ul, { subtree: true, attributes: true, attributeFilter: ["class"] });
    });
  }

  // Rodar no load e também depois de AJAX/HMR do editor
  function init() {
    bindThumbs();
    observeActiveSlides();
    // toca o slide ativo inicial (se for vídeo)
    document
      .querySelectorAll(".product__media-item.slider__slide.is-active")
      .forEach(playIn);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // alguns temas re-injetam a galeria; mantém tudo atualizado
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();
